import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatDialog} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {Activity} from '../../../models/applicationFeature';
import {CommonService} from '../../../services/common.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-form-creator',
    templateUrl: './form-creator.component.html',
    styleUrls: ['./form-creator.component.scss']
})
export class FormCreatorComponent implements OnInit {
    //#region class members
    pageTitle: string;
    htmlContent: any;
    questions: any;
    commentArea: boolean;
    formTitle: string;
    formTypes: any;
    selectedFormType: any;
    typesLoading: boolean;
    editMode: boolean;
    form: any;
    user: any;
    editorStyle: any;
    editorStylePreview: any;
    specificDate: any;
    minDate: any;
    isTwoStepActive: any;
    optionsStep: boolean;
    displayTitle: string;
    hasDeadline: boolean;
    hasForeignLanguage: boolean;
    selectedLanguage: any;
    languages: any;
    hasMaxSlots: boolean;
    maxSlots: number;
    hasFullInfo: boolean;
    contentWidth: any;
    selectedQuestions: any;
    isGDPR: boolean;
    formDescription: string;
    isAffirmation: boolean;
    hasClassRestriction: boolean;
    classes: any;
    activities: any;
    selectedActivity: Activity;
    selectedClassesRestriction: any;
    affirmationHasComments: boolean;
    isConsent: boolean;
    automations: any[];
    selectedAutomations: any[];
    departmentEmails: any[] = [];
    selectable = true;
    removable = true;
    addOnBlur = false;
    @ViewChild('divElement', {static: false}) divElement: ElementRef;
    @ViewChild('stepper', {static: false}) stepper: MatStepper;
    @ViewChild('emailInput', {static: false}) emailInput: ElementRef;
    @ViewChild('emailInput1', {static: false}) emailInput1: ElementRef;
    separatorKeysCodes = [ENTER, COMMA];

    emailsCtrl = new FormControl();
    emailsCtrl1 = new FormControl();

    filteredEmails: Observable<any[]>;
    emails: any[] = [];
    emails1: any[] = [];
    formUniqueId: string;
    isPageLoading = true;
    requestLoading = false;
    //#endregion

    //#region Constructor and OnInit functions
    constructor(private route: ActivatedRoute, private renderer: Renderer2, public commonService: CommonService,
                public router: Router, public dialog: MatDialog,
                public toastMessagesService: ToastMessagesService, private localStorageService: LocalStorageService,
                private sanitized: DomSanitizer, private cdr: ChangeDetectorRef) {
        this.htmlContent = '';
        this.commentArea = false;
        this.formTypes = [];
        this.typesLoading = true;
        this.editMode = false;
        this.editorStyle = {height: '500px'};
        this.editorStylePreview = {height: '100%;', border: '0px'};
        this.minDate = new Date();
        this.optionsStep = false;
        this.displayTitle = 'Τίτλος';
        this.hasDeadline = false;
        this.hasForeignLanguage = false;
        this.hasMaxSlots = false;
        this.maxSlots = 0;
        this.hasFullInfo = false;
        this.contentWidth = `width: ${window.innerWidth / 2}px`;
        this.isGDPR = false;
        this.formDescription = '';
        this.isAffirmation = false;
        this.hasClassRestriction = false;
        this.affirmationHasComments = false;
        this.isPageLoading = true;
    }


    async ngOnInit() {
        this.route.queryParams.subscribe(async (params) => {
            this.isTwoStepActive = true;
            this.form = JSON.parse(this.localStorageService.get('editForm'));
            this.editMode = params.mode === 'true';
            this.isConsent = params.consent === 'true';
            this.formUniqueId = params.uniqueId ? params.uniqueId : null;
            this.formTitle = ' ';
            this.user = JSON.parse(this.localStorageService.get('user'));
            if (this.isConsent) {
                if (this.editMode) {
                    this.pageTitle = 'Ενημέρωση δήλωσης';
                } else {
                    this.pageTitle = 'Δημιουργία δήλωσης';
                }
            } else {
                if (this.editMode) {
                    this.pageTitle = 'Ενημέρωση ανακοίνωσης';
                } else {
                    this.pageTitle = 'Δημιουργία ανακοίνωσης';
                }
            }
            // this.pageTitle = this.isConsent && !this.editMode ? 'Δημιουργία δήλωσης' : 'Δημιουργία ανακοίνωσης';
            // this.pageTitle = this.isConsent && this.editMode ? 'Ενημέρωση δήλωσης' : 'Ενημέρωση ανακοίνωσης';
            this.isPageLoading = true;
            try {
                await this.initQuestions();
                await this.initFormTypes();
                await this.initLanguages();
                await this.initClasses();
                await this.initActivities();
                await this.initAutomations();
                await this.initDepartmentEmails();
                if (!this.isConsent) {
                    this.selectedFormType = this.formTypes.find(type => type.id === 3);
                } else {
                    this.formTypes.splice(2, 1);
                }
                this.filteredEmails = this.emailsCtrl.valueChanges.pipe(
                    startWith(null),
                    map((email: any | null) => email ? this.filter(email) : this.departmentEmails.slice()));
            } catch (e) {
                console.log(e);
            } finally {
                this.isPageLoading = false;
                // Populate form after page is loaded so quill-editor is ready
                if (this.editMode) {
                    setTimeout(async () => {
                        await this.populateForm();
                        this.cdr.detectChanges();
                    }, 800);
                } else {
                    this.formTitle = '';
                }
            }
            // this.optionsStep = !this.selectedFormType || this.selectedFormType.id !== 3;
        });
    }

    next() {

        if (this.selectedFormType && this.selectedFormType.id === 1) {
            if (this.stepper.selectedIndex === 4) {

                const selectedQ = this.questions.filter(q => q.value === true);

                this.selectedQuestions = [];
                for (const question of selectedQ) {
                    const q = {
                        id: question.id,
                        title: question.title,
                        type: 'slider',
                        value: false
                    };

                    this.selectedQuestions.push(q);
                }

            }
        } else {
            if (this.stepper.selectedIndex === 2) {

                // this.renderer.setProperty(this.divElement.nativeElement, 'innerHTML', this.htmlContent);
            }
        }

    }

    //#endregion

    //#region Requests from Server
    async initFormTypes() {
        try {
            const categoriesRequest = await this.commonService.getList('forms/categories');
            this.formTypes = categoriesRequest.object.filter(type => type.id === 1 || type.id === 2 || type.id === 3);
        } catch (e) {
            this.toastMessagesService.toastMessages(`${e.message}`);
        } finally {
            this.typesLoading = false;
        }
    }

    async initDepartmentEmails() {
        try {
            const result = await this.commonService.getList(`college/emails`);
            this.departmentEmails = result.object;

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initActivities() {
        try {
            const activitiesRequest = await this.commonService.getList('activities');
            for (const activity of activitiesRequest.object) {
                const levelsRequest = await this.commonService.getList(`activities/assign?id=${activity.id}`);
                activity.assignedLevels = levelsRequest.object;
            }
            this.activities = activitiesRequest.object;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initQuestions() {
        try {
            const questionsRequest = await this.commonService.getList('forms/questions');
            this.questions = questionsRequest.object;
            for (const q of this.questions) {
                q.value = false;
            }
        } catch (e) {
            console.log(e.message);
        }
    }

    async initClasses() {
        try {
            const classesRequest = await this.commonService.getList('class');
            this.classes = classesRequest.object;
            for (const q of this.questions) {
                q.value = false;
            }
        } catch (e) {
            console.log(e.message);
        }
    }

    async initAutomations() {
        try {
            const automationsRequest = await this.commonService.getList('automation');
            for (const automation of automationsRequest.object) {
                automation.selected = false;
            }
            this.automations = automationsRequest.object;
        } catch (e) {
            console.log(e.message);
        }
    }

    async initLanguages() {
        try {
            const questionsRequest = await this.commonService.getList('languages');
            this.languages = questionsRequest.object;
        } catch (e) {
            console.log(e.message);
        }
    }

    //#endregion

    //#region helpers
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }

    changeQuestionState(index: number): void {
        this.questions[index].value = !this.questions[index].value;
    }

    invalidQuestionsStep(): boolean {
        const importedQuestions = this.questions.filter(question => question.value === true);

        return importedQuestions.length === 0;
    }

    affirmationHasCommentsChangedState() {
        this.affirmationHasComments = !this.affirmationHasComments;
    }

    commentAreaChange() {
        this.commentArea = !this.commentArea;
    }

    isFormInvalid(): boolean {
        return !(this.formTitle && this.selectedFormType && this.htmlContent);
    }

    //#endregion


    async submitForm() {
        this.requestLoading = true;
        let model = {
            htmlContent: '',
            consentFields: [],
            commentArea: false,
            requiresConsent: false,
        };

        if (this.selectedFormType.id === 1 || this.selectedFormType.id === 3) {
            const selectedQ = this.questions.filter(q => q.value === true);

            const selectedQuestions = [];
            for (const question of selectedQ) {
                const q = {
                    id: question.id,
                    title: question.title,
                    type: 'slider',
                    value: false
                };

                selectedQuestions.push(q);
            }

            model = {
                htmlContent: this.htmlContent,
                consentFields: selectedQuestions,
                commentArea: this.commentArea,
                requiresConsent: selectedQuestions.length > 0,
            };
        }

        const selectedEmails = [];
        for (const email of this.emails) {
            selectedEmails.push(email);
        }
        for (const email of this.emails1) {
            selectedEmails.push(email);
        }

        const automations = this.automations.filter(automation => automation.selected);
        const selectedAutomations = [];
        for (const automation of automations) {
            const automationModel = {
                id: automation.id,
                emails: automation.id === 1 ? this.emails : this.emails1
            };
            selectedAutomations.push(automationModel);
        }


        const content = {
            content: this.selectedFormType.id !== 2 ? JSON.stringify(model) : JSON.stringify(this.htmlContent),
            title: this.formTitle,
            description: this.formDescription,
            typeId: this.selectedFormType.id,
            modified_from_user_id: this.user.id,
            // hasDeadLine: this.hasDeadline,
            hasDeadLine: this.hasDeadline && this.specificDate ? new Date(this.specificDate) : null,
            deadlineDate: this.specificDate ? new Date(this.specificDate) : null,
            hasComments: this.commentArea,
            hasMaxSlots: this.hasMaxSlots,
            maxSlots: this.hasMaxSlots ? this.maxSlots : null,
            hasTwoFactor: this.isTwoStepActive,
            hasFullInfo: this.hasFullInfo,
            hasForeignLanguage: this.hasForeignLanguage,
            language_id: this.selectedLanguage ? this.selectedLanguage.id : null,
            isGDPR: this.selectedFormType.id === 1,
            automations: selectedAutomations.length > 0 ? JSON.stringify(selectedAutomations) : null,
            activity_id: this.selectedFormType.id === 2 ? this.selectedActivity.id : null,
        };

        try {
            if (!this.editMode) {
                // Insert form
              await this.commonService.insertItem('forms', content);
            } else {
                // Update form
                const result =  await this.commonService.updateItem(`forms?uniqueId=${this.formUniqueId}`, content);
                console.log(result);
            }
            if (this.isConsent) {
                const message = this.editMode ? 'Η ενημέρωση της δήλωσης ολοκληρώθηκε με επιτυχία' :
                    'Η δημιουργία της δήλωσης ολοκληρώθηκε με επιτυχία';
                this.toastMessagesService.toastMessages(message);
                await this.router.navigate(['home/forms']);
            } else {
                const message = this.editMode ? 'Η ενημέρωση της ανακοίνωσης ολοκληρώθηκε με επιτυχία' :
                    'Η δημιουργία της ανακοίνωσης ολοκληρώθηκε με επιτυχία';
                this.toastMessagesService.toastMessages(message);
                await this.router.navigate(['home/announcement-page']);
            }
        } catch (e) {
            console.log(e.message);
            this.toastMessagesService.toastMessages(`${e.message}`);
        } finally {
            this.requestLoading = false;
        }
    }

    isConsentForm(): boolean {
        // tslint:disable-next-line:max-line-length
        return this.selectedFormType && (this.selectedFormType.id === 1 || this.selectedFormType.id === 4 || this.selectedFormType.id === 5);
    }

    canHaveCommentArea(): boolean {
        // tslint:disable-next-line:max-line-length
        return this.selectedFormType && (this.selectedFormType.id === 1 || this.selectedFormType.id === 2 || this.selectedFormType.id === 4 || this.selectedFormType.id === 5);
    }

    twoStepChange() {
        this.isTwoStepActive = !this.isTwoStepActive;
    }

    isFirstStepInvalid() {
        return !(this.formTitle && this.selectedFormType);
    }

    categoryChanged() {
        if (this.selectedFormType && this.selectedFormType.id) {
            this.displayTitle = this.selectedFormType.id === 1 ? 'Τίτλος δήλωσης' : this.selectedFormType.id === 2 ?
                'Τίτλος δήλωσης' : 'Τίτλος Ανακοίνωσης';
            this.optionsStep = this.selectedFormType.id !== 3;
            this.isAffirmation = this.selectedFormType.id === 2;
        }
    }

    hasDeadLineChanged(event) {
        this.hasDeadline = event.checked;
        this.hasForeignLanguage = false;
    }

    hasForeignLanguageChanged(event) {
        this.hasForeignLanguage = event.checked;
        this.hasDeadline = false;
        this.hasMaxSlots = false;
    }

    hasMaxSlotsChanged(event) {
        this.hasMaxSlots = event.checked;
        this.hasForeignLanguage = false;
    }

    hasFullInfoChanged(event) {
        this.hasFullInfo = event.checked;
    }

    isGDPRchanged() {
        this.isGDPR = !this.isGDPR;
    }

    classRestrictionChanged() {
        this.hasClassRestriction = !this.hasClassRestriction;
    }

    automationSelection(id) {
        const currentAutomation = this.automations.find(auto => auto.id === id);
        if (currentAutomation) {
            currentAutomation.selected = !currentAutomation.selected;
        }
    }

    removeEmail(email: any) {
        const index = this.emails.indexOf(email);

        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    removeEmail1(email: any) {
        const index = this.emails1.indexOf(email);

        if (index >= 0) {
            this.emails1.splice(index, 1);
        }
    }

    addEmail($event: any) {
        // @ts-ignore
        const input = event.input;
        // @ts-ignore
        const value = event.value;

        // Add email
        if ((value || '').trim()) {
            this.emails.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }

        this.emailsCtrl.setValue(null);
    }

    addEmail1($event: any) {
        // @ts-ignore
        const input = event.input;
        // @ts-ignore
        const value = event.value;

        // Add email
        if ((value || '').trim()) {
            this.emails1.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }

        this.emailsCtrl1.setValue(null);
    }

    filter(name: string) {
        try {
            if (name) {
                return this.departmentEmails.filter(email =>
                    email.email.toLowerCase().indexOf(name.toLowerCase()) === 0);
            }
        } catch (e) {

        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        this.emails.push(event.option.viewValue);
        this.emailInput.nativeElement.value = '';
        this.emailsCtrl.setValue(null);
    }

    selected1(event: MatAutocompleteSelectedEvent): void {
        this.emails1.push(event.option.viewValue);
        this.emailInput1.nativeElement.value = '';
        this.emailsCtrl1.setValue(null);
    }


    //#region Edit Form
    async populateForm() {
        console.log('=== populateForm STARTED ===');
        console.log('formUniqueId:', this.formUniqueId);
        try {
            const form = await this.initEditForm();
            console.log('=== Form from API ===');
            console.log('form:', form);
            console.log('form.content:', form?.content);
            console.log('form.form_type_id:', form?.form_type_id);
            if (form) {
                this.populateFirstStep(form.form_type_id, form.title, form.description);
                this.populateSecondStep(form.form_type_id, form.content);
                this.populateThirdStep(form.form_type_id, form.form_type_id === 1 ? form.content : form.activity_id);
                const propertiesModel = {
                    hasTwoFactor: form.has_two_factor,
                    hasComments: form.has_comments,
                    hasDeadLine: form.has_deadline,
                    deadLineDate: form.deadline_date,
                    hasMaxSlots: form.has_max_slots,
                    maxSlots: form.max_slots,
                    hasFullInfo: form.has_full_info,
                };
                this.populateFourthStep(form.form_type_id, propertiesModel);
                this.populateFifthStep(form.form_type_id, form.automations);
                console.log('=== After all populate steps ===');
                console.log('this.htmlContent:', this.htmlContent);
            } else {
                console.log('=== Form is NULL ===');
                this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να βρούμε την αντίστοιχη φόρμα');
            }
        } catch (e) {
            console.log('=== populateForm ERROR ===', e);
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initEditForm() {
        console.log('=== initEditForm called ===');
        console.log('API URL:', `forms/formWithContent?uniqueId=${this.formUniqueId}`);
        try {
            const formRequest = await this.commonService.getList(`forms/formWithContent?uniqueId=${this.formUniqueId}`);
            console.log('=== API Response ===');
            console.log('formRequest:', formRequest);
            return formRequest.object;
        } catch (e) {
            console.log('=== initEditForm ERROR ===', e);
            this.toastMessagesService.toastErrorMessage(e.message);
            return null;
        }
    }

    populateFirstStep = (formTypeId: number, formTitle: string, formSubTitle: string) => {
        const selectedType = this.formTypes.find(type => type.id === formTypeId);
        if (selectedType) {
            this.selectedFormType = selectedType;
            this.categoryChanged();
        }

        this.formTitle = formTitle;
        this.formDescription = formSubTitle;
    }

    populateSecondStep = (formTypeId: number, content: string) => {
        console.log('[populateSecondStep] formTypeId:', formTypeId, 'content:', content);
        if (formTypeId === 1 || formTypeId === 3) {
            const tempContent = JSON.parse(content);
            console.log('[populateSecondStep] tempContent:', tempContent);
            this.htmlContent = tempContent.htmlContent || '';
            console.log('[populateSecondStep] htmlContent:', this.htmlContent);
        } else {
            this.htmlContent = JSON.parse(content);
        }
        // Trigger change detection to update the quill-editor
        this.cdr.detectChanges();
    }

    populateThirdStep = (formTypeId: number, params: any) => {
        if (formTypeId === 1) {
            const tempContent = JSON.parse(params);
            const questions = tempContent.consentFields;
            for (const question of questions) {
                const currentQuestion = this.questions.find(q => q.id === question.id);
                if (currentQuestion) {
                    currentQuestion.value = true;
                }
            }
        } else {
            const selectedActivity = this.activities.find(activity => activity.id === +params);
            if (selectedActivity) {
                this.selectedActivity = selectedActivity;
            }
        }
    }

    populateFourthStep = (formTypeId: number, properties: any) => {
        if (formTypeId === 1) {
            this.isTwoStepActive = properties.hasTwoFactor === 1;
            this.hasDeadline = properties.hasDeadLine === 1;
            this.specificDate = properties.hasDeadLine === 1 ? this.formatSimpleDate(properties.deadLineDate) : '';
            this.hasMaxSlots = properties.hasMaxSlots === 1;
            this.maxSlots = properties.hasMaxSlots === 1 ? properties.maxSlots : '';
            this.hasFullInfo = properties.hasFullInfo === 1;
            console.log(this.specificDate);
        }

        if (formTypeId === 2) {
            this.isTwoStepActive = properties.hasTwoFactor === 1;
            this.commentArea = properties.hasComments === 1;
            this.hasDeadline = properties.hasDeadLine === 1;
            this.specificDate = properties.hasDeadLine === 1 ? properties.deadLineDate : '';
            this.hasMaxSlots = properties.hasMaxSlots === 1;
            this.maxSlots = properties.hasMaxSlots === 1 ? properties.maxSlots : '';
        }
    }

    formatSimpleDate(dateString) {
        const tempDate = dateString.split('-');
        return new Date(`${tempDate[2]}/${tempDate[1]}/${tempDate[0]}`);
    }

    populateFifthStep = (formTypeId: number, automations) => {
        if (formTypeId !== 3) {
            const automationObject = JSON.parse(automations);
            if (automationObject && automationObject.length > 0) {
                for (const automation of automationObject) {
                    const currentAutomation = this.automations.find(a => a.id === automation.id);
                    if (currentAutomation) {
                        currentAutomation.selected = true;
                        if (automation.id === 1) {
                            this.emails = automation.emails;
                        }
                        if (automation.id === 2) {
                            this.emails1 = automation.emails;
                        }
                    }
                }
            }
        }
    }

    // Handler για το quill-editor - ενημερώνει τον editor με το υπάρχον content
    onEditorCreated(editor: any) {
        console.log('=== Editor Created ===');
        console.log('Current htmlContent:', this.htmlContent);
        if (this.htmlContent && this.editMode) {
            // Περιμένουμε λίγο για να σιγουρευτούμε ότι ο editor είναι έτοιμος
            setTimeout(() => {
                editor.root.innerHTML = this.htmlContent;
                console.log('Editor content set to:', this.htmlContent);
            }, 100);
        }
    }
    //#endregion
}
